module.exports = __webpack_public_path__ + "static/web-device-spoofing-c71fc5a9e55fcc0f4a6f8816875a7c59.gif";